import React, { useContext } from 'react';
import { MultiResolutionBackgroundDiv } from '@domain-group/fe-co-multi-resolution-image';
import { MediaContext } from 'react-media-query-hoc';
import { Banner, Subtitle } from '../hero-text';
import * as styles from './hero-image.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var usePlatformProp = prop => {
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    tablet = _useContext.tablet;
  if (!prop) {
    return prop;
  }
  if (typeof prop === 'object' && 'desktop' in prop && 'mobile' in prop) {
    if (mobile) {
      return prop.mobile;
    }
    if (tablet && prop.tablet) {
      return prop.tablet;
    }
    return prop.desktop;
  }
  return prop;
};
export var HeroImage = _ref => {
  var banner = _ref.banner,
    subtitle = _ref.subtitle,
    image = _ref.image,
    _ref$seed = _ref.seed,
    seed = _ref$seed === void 0 ? 0 : _ref$seed,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var bannerConfig = usePlatformProp(banner);
  var subtitleConfig = usePlatformProp(subtitle);
  var imageConfig = usePlatformProp(image);
  var images = Array.isArray(imageConfig) ? imageConfig : [imageConfig];
  var _images = images[seed % images.length],
    highResUrl = _images.highResUrl,
    lowResUrl = _images.lowResUrl;
  return ___EmotionJSX(MultiResolutionBackgroundDiv, {
    src: highResUrl,
    srcLowResolution: lowResUrl || highResUrl,
    css: styles.container,
    className: className
  }, ___EmotionJSX("div", {
    css: styles.titles
  }, bannerConfig && ___EmotionJSX(Banner, {
    config: bannerConfig,
    seed: seed
  }), subtitleConfig && ___EmotionJSX(Subtitle, {
    config: subtitleConfig,
    seed: seed
  })), children);
};